import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKeys } from '../keys';
import { request } from '../request';
import { userQueryOptions } from './useUser';

export const useAuthorizeBillit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (authorizationCode: string) => {
      const body = { code: authorizationCode };
      return request('/oauth2/callback/billit', { method: 'POST', body });
    },
    onSuccess: () => {
      queryClient.setQueryData(userQueryOptions.queryKey, (user) => {
        if (!user) return;

        return { ...user, integrations: { ...user.integrations, billit: true } };
      });
      queryClient.invalidateQueries({ queryKey: QueryKeys.user });
    },
  });
};
